module.exports = __webpack_public_path__ + "img/content5_520_15.d3803854.png";